import { useNavigate } from "react-router-dom";
import { KWordmark } from "@/components/KLogo";
import { ArrowLeft } from "lucide-react";

export default function AuthShell({ title, subtitle, children, testid }) {
  const nav = useNavigate();
  return (
    <div className="min-h-[100dvh] bg-background relative overflow-hidden" data-testid={testid}>
      <div className="absolute inset-0 aurora opacity-70" />
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="relative min-h-[100dvh] flex flex-col">
        <div className="p-5 flex items-center justify-between">
          <button onClick={() => nav("/")} className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="auth-back">
            <ArrowLeft className="w-4 h-4" /> Voltar
          </button>
          <KWordmark size={30} />
        </div>
        <div className="flex-1 flex items-start md:items-center justify-center px-5 pb-10">
          <div className="w-full max-w-md glass-strong rounded-3xl border border-white/10 p-6 md:p-8 float-in glow-soft">
            <h1 className="font-display font-bold text-2xl tracking-tight">{title}</h1>
            {subtitle && <p className="text-sm text-muted-foreground mt-1.5">{subtitle}</p>}
            <div className="mt-6">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export const Field = ({ label, ...props }) => (
  <label className="block">
    <span className="text-xs font-medium text-muted-foreground">{label}</span>
    <input
      {...props}
      className="mt-1.5 w-full rounded-xl bg-white/5 border border-white/10 px-4 py-2.5 text-sm outline-none focus:border-primary/60 transition-colors placeholder:text-muted-foreground/60"
    />
  </label>
);

export const PrimaryBtn = ({ loading, children, ...props }) => (
  <button
    {...props}
    disabled={loading || props.disabled}
    className="w-full rounded-full brand-gradient glow-primary py-3 font-semibold text-white active:scale-95 hover:scale-[1.01] transition-transform disabled:opacity-60"
  >
    {loading ? "Aguarde..." : children}
  </button>
);
